import { formatInTimeZone } from 'date-fns-tz';
import { isEmpty } from 'lodash-es';
import { useMemo } from 'react';
import { StatLabel } from 'src/components/Listings/InventoryEventPage/InventoryEventDetail/components/Map/StatLabel';
import { Content } from 'src/contexts/ContentContext';
import { useSiteTimezoneContext } from 'src/contexts/SiteTimezoneContext/SiteTimezoneContext';
import { Button, Stack } from 'src/core/ui';
import { ContentId } from 'src/utils/constants/contentId';
import { getListingActionButtons } from 'src/utils/inventoryUtils';
import { getLocaleFromLanguageOrCurrent } from 'src/utils/localeUtils';
import { Event, Listing } from 'src/WebApiController';

import { PredeliveryActionTypes } from '../MobileListingActionsDrawer';
import * as styles from '../views/MobileListingDetailsView.css';

export const MobileListingStats = ({
  event,
  listing,
  onOpenActions,
}: {
  event: Event;
  listing: Listing;
  onOpenActions: () => void;
}) => {
  const { timeZone } = useSiteTimezoneContext();

  const inHandDateString = useMemo(() => {
    if (listing.inHandAt) {
      return formatInTimeZone(new Date(listing.inHandAt), timeZone, 'MM/dd', {
        locale: getLocaleFromLanguageOrCurrent(),
      });
    }
    return undefined;
  }, [listing.inHandAt, timeZone]);

  const listingActions = getListingActionButtons(
    true,
    listing,
    listing.actions.filter((a) => PredeliveryActionTypes.includes(a)),
    event,
    undefined,
    true,
    undefined,
    false,
    undefined /* lockListingGroupFromEdits */,
    undefined /* onSetListingActiveInGroup */,
    'fullscreen'
  );

  return (
    <Stack
      direction="row"
      width="full"
      justifyContent="spaceBetween"
      alignItems="center"
    >
      <Stack direction="row" gap="m">
        <StatLabel
          stat={listing.unitCst?.disp ?? listing.faceValue?.disp}
          title={<Content id={ContentId.UnitCost} />}
        />
        <StatLabel
          stat={inHandDateString}
          title={<Content id={ContentId.InHand} />}
        />
        <StatLabel
          stat={listing.topPriTktType ?? ''}
          title={<Content id={ContentId.Delivery} />}
        />
      </Stack>
      <Stack direction="row" gap="m">
        {!isEmpty(listingActions) && (
          <div className={styles.deliveryIcon}>{listingActions}</div>
        )}
        <Button shape="rect" variant="outline" onClick={onOpenActions}>
          <Content id={ContentId.Actions} />
        </Button>
      </Stack>
    </Stack>
  );
};
